/**
 * The note text a user has typed and not saved, for one record (F1-e spec FR-P2, FR-K1; WI-1.4 plan
 * Decisions 21, 22 and 30). Held above the *Notes* section — by the account panel, the contact action,
 * or F1-f's contact-view adapter — so the text survives the section remounting (the contact dialog's
 * content remounted to ask before it closes) and its holder can ask before the text is lost.
 */

/** The open edit of one note: what it was opened on, and what is in the box now. */
export interface NoteEditDraft {
    readonly noteId: number;
    /** The `version` the edit will send (`NotePatchRequest`). */
    readonly version: number;
    /** The note's body when the edit was opened, or as last re-read through *Reload*. */
    readonly original: string;
    readonly text: string;
}

export interface NoteDrafts {
    /** The add box's text, as typed. */
    readonly add: string;
    /** The note being edited, if any — one at a time. */
    readonly edit: NoteEditDraft | null;
}

export const EMPTY_DRAFTS: NoteDrafts = { add: '', edit: null };

/** True when leaving would lose typed text: the add box is not empty, or an open edit differs from its note. */
export function hasUnsavedNote(drafts: NoteDrafts): boolean {
    return drafts.add !== '' || (drafts.edit !== null && drafts.edit.text !== drafts.edit.original);
}
